import React from 'react';

export default () => (
  <span>
    <img src="https://storage.googleapis.com/russellmschmidt-net-portfolio/icons/medal-icons/icons8-bronze-medal-48.png" alt="3rd place bronze medal" />
  </span>
);




// WEBPACK FOOTER //
// ./src/components/MedalBronze.js